"use client";

import { Property } from "@/lib/types/marketsuite/datatypes/property";
import { PropertyFavoriteButton } from "@/blocks/marketsuite/property-details/favorite-button";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { Image } from "../../ui/image";

interface PropertyCTABarProps {
	propertyData: Property | undefined;
}

export const PropertyCTABar: React.FC<PropertyCTABarProps> = ({ propertyData }) => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setIsVisible(window.scrollY > 160 && window.innerHeight + window.scrollY < document.documentElement.scrollHeight - 240);
		};

		handleScroll();
		window.addEventListener("scroll", handleScroll, { passive: true });

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [propertyData]);

	if (!propertyData) return null;

	return (
		<div
			className={cn(
				"fixed bottom-0 border-t border-(--ms-color-border) bg-(--bg-body) w-full transition duration-300 shadow-[0_-10px_15px_-3px_rgb(0_0_0/0),0_-4px_6px_-4px_rgb(0_0_0/0.07)]",
				!isVisible && "translate-y-40",
			)}
		>
			<div className="max-w-7xl mx-auto not-xs:items-center gap-3 flex justify-between px-2 py-4">
				<div className="flex gap-2">
					<figure className="w-20 relative rounded-sm overflow-hidden hidden sm:hidden">
						<Image src={propertyData.media.primary_photo} width={50} height={50} fill alt="Main property image" />
					</figure>

					<div className="flex flex-col">
						<p className="h1 text-xs! xs:text-base! sm:text-xl!">{propertyData.title}</p>
						<p className="text-xs sm:text-base">
							{propertyData.address.postal_code}, {propertyData.address.location}
						</p>
					</div>
				</div>

				<div>
					<PropertyFavoriteButton hideLabelMobile={true} id={propertyData.id} importType={propertyData.import_type} />
				</div>
			</div>
		</div>
	);
};
